const getAge = (birth_date: string): number => {
  const bd  = new Date(birth_date);

  const now = new Date();
  const thisBd = new Date(now.getFullYear(), bd.getMonth(), bd.getDate());

  const age = now.getFullYear() - bd.getFullYear();

  //今年の誕生日を迎えていなければage-1を返す
  return (now < thisBd) ? age-1 : age;
}

const toActiveInWord = (activeInHour: number) => {
  let activeIn = '';
  if (activeInHour <= 24) {
    activeIn = '24時間以内';
  } else if (activeInHour <= 24 * 3) {
    activeIn = '3日以内';
  } else if (activeInHour <= 24 * 7) {
    activeIn = '1週間以内';
  } else if (activeInHour <= 24 * 14) {
    activeIn = '2週間以内';
  } else if (activeInHour <= 24 * 31) {
    activeIn = '1ヶ月以内';
  } else if (activeInHour <= 24 * 93) {
    activeIn = '3ヶ月以内';
  } else {
    activeIn = '3ヶ月以上';
  }
  return activeIn;
}

const isIn6Month = (date: string) => {
  const now = new Date();

  const sixMonthAgo = new Date();
  sixMonthAgo.setMonth(now.getMonth()-6);
  sixMonthAgo.setDate(now.getDate()-1);

  return sixMonthAgo < new Date(date);
}

// import { ja } from '../locales/ja';
// const val = (ctgr, key) => {
//   return ja[ctgr][key]
// }

const thousandSeparate = (num: number) => {
  return String(num) && String(num).replace( /(\d)(?=(\d\d\d)+(?!\d))/g, '$1,');
}

// const parse_query = (location_search: string) => {
//   let arg = new Object;
//   const pair = location_search.substring(1).split('&');
//   for (let i=0; pair[i]; i++) {
//     const kv = pair[i].split('=');
//     arg[kv[0]: string] = kv[1];
//   }
//   return arg;
// }

const toLocalDate = (utc_string: string) => {
  const utc = new Date(utc_string);
  const offset = -1 * utc.getTimezoneOffset() / 60;
  const local = new Date(utc.getTime() + (offset * 3600000));
  return local;
}

const toDateStr = (date: Date) => {
  if (date) {
    const month = ('0' + (date.getMonth() + 1)).slice(-2);
    const day = ('0' + date.getDate()).slice(-2);
    return `${ date.getFullYear() }-${ month }-${ day }`;
  } else {
    return "";
  }
}

const autoLink = (str: string) =>  {
    const regexp_url = /((h?)(ttps?:\/\/[a-zA-Z0-9.\-_@:/~?%&;=+#',()*!]+))/g; // ']))/;
    const regexp_makeLink = function(all: string, url: string, h: string, href: string) {
        return '<a href="h' + href + '" target="_blank">' + url + '</a>';
    }

    return str.replace(regexp_url, regexp_makeLink);
}

const toDispInitial = (initial: string) => {
  if (initial.match(/^[A-Z]{2}$/)) {
    return initial.charAt(0) + "." + initial.charAt(1);
  } else {
    return initial;
  }
}

const funcs = {
  getAge,
  toActiveInWord,
  isIn6Month,
  // val,
  thousandSeparate,
  // parse_query,
  toLocalDate,
  toDateStr,
  autoLink,
  toDispInitial
}

export default funcs;
